import { useState, useEffect } from 'react';

const useLockScreen = (state: boolean) => {
    const [locked, setLocked] = useState(false);

    useEffect(() => {
        if (state) {
            // If the modal is open, lock the screen
            document.body.style.overflow = 'hidden';
            setLocked(true);
        } else {
            // If the modal is closed, unlock the screen
            document.body.style.overflow = 'auto';
            setLocked(false);
        }

        // Cleanup function to reset overflow style
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [state]);

    return locked;
};

export default useLockScreen;
